import { IIconSubset, registerIcons, setIconOptions } from '@fluentui/react';
import { IconSet } from './IconSet';

const DEFAULT_BASE_URL = 'https://cdn.fluidpreview.office.net/fluid/prod/hashed-assets/fonts/';

// Used to view changes on our PR Deployments, since the icons would not had been deployed to the CDN
const PR_DEPLOYMENTS_URL = 'https://officefluidprdeployments.azurewebsites.net/assets/fonts/';

export function initializeIconSet(iconSet: IconSet, baseUrl?: string): void {
  const { fontFamily, fontExtension, icons, sha } = iconSet;

  let srcURL = baseUrl || DEFAULT_BASE_URL;

  if (PR_DEPLOYMENTS_URL.indexOf(window.origin) === 0) {
    srcURL = PR_DEPLOYMENTS_URL;
  }

  const subset: IIconSubset = {
    style: {
      MozOsxFontSmoothing: 'grayscale',
      WebkitFontSmoothing: 'antialiased',
      fontStyle: 'normal',
      fontWeight: 'normal',
      speak: 'none'
    },
    fontFace: {
      fontFamily: `"${fontFamily}"`,
      src: `url('${srcURL}${fontFamily}-${sha}.${fontExtension}') format('${fontExtension}')`
    },
    icons
  };

  setIconOptions({ disableWarnings: true });
  registerIcons(subset);
}
